import {
  myTasksQueryKey,
  taskByIdQueryKey,
  taskEventsQueryKey,
  tasksQueryKey,
} from '@cartwheel/api/v1'
import { useToast } from '@cartwheel/components'
import { useQueryClient } from '@tanstack/react-query'

export function useTaskCompletion({ taskId, onClose }: { taskId: string; onClose: () => void }) {
  const queryClient = useQueryClient()
  const toast = useToast()

  const onSuccess = (description: string) => {
    void queryClient.invalidateQueries({ queryKey: myTasksQueryKey() })
    void queryClient.invalidateQueries({ queryKey: tasksQueryKey() })
    void queryClient.invalidateQueries({ queryKey: taskByIdQueryKey({ path: { id: taskId } }) })
    void queryClient.invalidateQueries({
      queryKey: taskEventsQueryKey({ path: { task_id: taskId } }),
    })
    toast.success({ description })
    onClose()
  }

  const onError = (description: string) => {
    toast.error({ description })
  }

  return { onSuccess, onError }
}
